import { addressBookStyles as styles } from "@insite/content-library/Widgets/Addresses/AddressBook";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.gridContainer = {
    ...styles.gridContainer,
    css: css`
        ${styles.gridContainer?.css}
        ${mediaQueriesBP.minMD} {
            padding-left: 24px;
        }
    `,
};

styles.titleTextGridItem = {
    ...styles.titleTextGridItem,
};

styles.titleText = {
    ...styles.titleText,
    variant: "h4",
    css: css`
        border-bottom: 1px solid ${getColor(colorStrings.commonBorder)};
        width: 100%;
        padding-bottom: 19px;
        margin-bottom: 0;
    `,
};

styles.addressCard = {
    ...styles.addressCard,
    actionUseAsShippingAddressButton: {
        ...styles.addressCard?.actionUseAsShippingAddressButton,
        color: "primary",
    },

    addressInfoDisplay: {
        ...styles.addressCard?.addressInfoDisplay,
        address1Text: {
            ...styles.addressCard?.addressInfoDisplay?.address1Text,
            css: css`
                ${styles.addressCard?.addressInfoDisplay?.address1Text?.css}
                line-height: 180%;
                ${mediaQueriesBP.maxMD} {
                    font-size: 14px;
                }
            `,
        },
        customerNameText: {
            ...styles.addressCard?.addressInfoDisplay?.customerNameText,
            css: css`
                ${styles.addressCard?.addressInfoDisplay?.customerNameText?.css}
                line-height: 180%;
                ${mediaQueriesBP.maxMD} {
                    font-size: 14px;
                }
            `,
        },
        attentionText: {
            ...styles.addressCard?.addressInfoDisplay?.attentionText,
            css: css`
                ${styles.addressCard?.addressInfoDisplay?.attentionText?.css}
                line-height: 180%;
                ${mediaQueriesBP.maxMD} {
                    font-size: 14px;
                }
            `,
        },
        companyNameText: {
            ...styles.addressCard?.addressInfoDisplay?.companyNameText,
            css: css`
                ${styles.addressCard?.addressInfoDisplay?.companyNameText?.css}
                line-height: 180%;
                ${mediaQueriesBP.maxMD} {
                    font-size: 14px;
                }
            `,
        },
        address2Text: {
            ...styles.addressCard?.addressInfoDisplay?.address2Text,
            css: css`
                ${styles.addressCard?.addressInfoDisplay?.address2Text?.css}
                line-height: 180%;
                ${mediaQueriesBP.maxMD} {
                    font-size: 14px;
                }
            `,
        },
        address3Text: {
            ...styles.addressCard?.addressInfoDisplay?.address3Text,
            css: css`
                ${styles.addressCard?.addressInfoDisplay?.address3Text?.css}
                line-height: 180%;
                ${mediaQueriesBP.maxMD} {
                    font-size: 14px;
                }
            `,
        },
        address4Text: {
            ...styles.addressCard?.addressInfoDisplay?.address4Text,
            css: css`
                ${styles.addressCard?.addressInfoDisplay?.address4Text?.css}
                line-height: 180%;
                ${mediaQueriesBP.maxMD} {
                    font-size: 14px;
                }
            `,
        },
        cityStatePostalCodeText: {
            ...styles.addressCard?.addressInfoDisplay?.cityStatePostalCodeText,
            css: css`
                ${styles.addressCard?.addressInfoDisplay?.cityStatePostalCodeText?.css}
                line-height: 180%;
                ${mediaQueriesBP.maxMD} {
                    font-size: 14px;
                }
            `,
        },
        countryText: {
            ...styles.addressCard?.addressInfoDisplay?.countryText,
            css: css`
                ${styles.addressCard?.addressInfoDisplay?.countryText?.css}
                line-height: 180%;
                ${mediaQueriesBP.maxMD} {
                    font-size: 14px;
                }
            `,
        },
        phoneText: {
            ...styles.addressCard?.addressInfoDisplay?.phoneText,
            css: css`
                ${styles.addressCard?.addressInfoDisplay?.phoneText?.css}
                line-height: 180%;
                ${mediaQueriesBP.maxMD} {
                    font-size: 14px;
                }
            `,
        },
        emailText: {
            ...styles.addressCard?.addressInfoDisplay?.emailText,
            css: css`
                ${styles.addressCard?.addressInfoDisplay?.emailText?.css}
                line-height: 180%;
                ${mediaQueriesBP.maxMD} {
                    font-size: 14px;
                }
            `,
        },
        faxText: {
            ...styles.addressCard?.addressInfoDisplay?.faxText,
            css: css`
                ${styles.addressCard?.addressInfoDisplay?.faxText?.css}
                line-height: 180%;
                ${mediaQueriesBP.maxMD} {
                    font-size: 14px;
                }
            `,
        },
    },
};
